import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { baseURL } from '../config'
import TreeView from './TreeView'
import { AccordionArrow } from './Icons'
import LoadingAnimation from './LoadingAnimation'

function Accordion({ modsId, item, index }) {
    const [documentItems, setDocumentItems] = useState()
    const [fetchingDocumentItems, setFetchingDocumentItems] = useState()
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        const fetchDocumentItems = async () => {
            try {
                setFetchingDocumentItems(true)
                const response = await axios.get(`${baseURL}/mods/getAssetsBydocument/${modsId}`, {
                    headers: {
                        "ngrok-skip-browser-warning": "any",
                        "Content-Type": "multipart/form-data",
                    },
                    params: {
                        assetType: item
                    }
                });
                setDocumentItems(response.data.data.data)
            } catch (error) {
                console.error('fetchDocumentItems Error:', error);
            } finally {
                setFetchingDocumentItems(false)
            }
        };

        fetchDocumentItems()
    }, [item, modsId]);

    return (
        <div className={`w-full border-b border-[#E8EBF1]`}>
            <button
                type='button'
                aria-expanded={isOpen}
                className={`w-full flex items-center gap-4 text-left py-5 px-4 md:px-6 ${isOpen ? 'bg-[#F4F5F8]' : 'hover:bg-[#F4F5F8]'}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className='font-bold text-sm text-[#A8871B] min-w-[26px]'>{index}</span>
                <span className='font-bold text-base md:text-lg text-[#131F38]'>{item}</span>
                <span className={`ml-auto w-[30px] h-[30px] border border-[#D9DDE6] flex items-center justify-center flex-none transition-transform ${isOpen ? 'rotate-180' : ''}`}>
                    <AccordionArrow />
                </span>
            </button>
            {isOpen && (
                fetchingDocumentItems ? (
                    <LoadingAnimation />
                ) : (
                    <div className='overflow-x-auto pb-6 px-4 md:px-6'>
                        <TreeView data={documentItems} item={item} />
                    </div>
                )
            )}
        </div>
    )
}

export default Accordion